import isFinite from "lodash.isfinite";
import { md5 } from "js-md5";
export type TestConfig = {
  name: string;
  weight: number;
};

export class ABTest {
  constructor(private name: string, private config: TestConfig[]) {}

  static createTest(name: string, config: TestConfig[]): ABTest {
    if (typeof name !== "string") {
      throw Error("Insert a valid name for the test");
    }

    const testData = initTest(config);

    return new ABTest(name, testData);
  }

  getName(): string {
    return this.name;
  }

  getGroup(user: string): string {
    if (user === undefined || typeof user !== "string") {
      throw Error("Undefined user to give it a random group");
    }

    const hexMD5hash = md5.hmac.hex(this.name, user).slice(0, 8);
    const hashAsInt = parseInt("0x" + hexMD5hash, 16);
    const maxInt = parseInt("0xffffffff", 16);
    const random = hashAsInt / maxInt;

    var filtered = this.config.filter(function (t) {
      return t.weight > random;
    });
    if (filtered.length === 0) throw Error("Error filtering the tests");

    return filtered[0].name;
  }

  test(testGroupName: string, functions: Function[], that?: any) {
    if (typeof testGroupName !== "string")
      throw Error("Test Group is not a string");

    if (!Array.isArray(functions))
      throw Error("Introduce an array of functions as a second parameter");

    if (functions.length !== this.config.length)
      throw Error(
        "The number of functions does not match the number of test groups"
      );

    var pluckedValues = this.config.map(function (data) {
      return data.name;
    });
    var index = pluckedValues.indexOf(testGroupName);

    if (index === -1) throw Error("Test Group not found");

    if (that === undefined) that = this;

    functions[index].apply(that, functions[index].arguments);
  }
}

const initTest = (config: TestConfig[]): TestConfig[] => {
  const defaultWeight = 0.5;
  let accumulativeWeight = 0;

  if (!Array.isArray(config)) {
    throw Error("Module not configured. Check your configuration.");
  }

  // If no weight is provided, we give a static weight
  const totalWeight = config
    .map(function (o) : number {
      return isFinite(o.weight) ? o.weight ?? defaultWeight: defaultWeight;
    })
    .reduce(function (a, b) {
      return a + b;
    });

  const tests = config.filter((test) => test.name && typeof test.name === "string")
    .map(function (test) {
        return {
          // Weight from 0..1
          weight:
            (isFinite(test.weight) ? test.weight ?? defaultWeight : defaultWeight) / totalWeight,
          name: test.name,
        };
    })
    .sort(function (a, b) {
      return b.weight - a.weight;
    });

  tests.forEach(function (o) {
    o.weight += accumulativeWeight;
    accumulativeWeight = o.weight;
  });
  return tests;
};
